"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=13%3A370))
 * @trackcomponent
 * @lastsynced 2025-04-11T14:43:36.745Z
 * @optimized using svgo:^3.0.2
 */
export const UnitedStates = createSVGIcon(
  <>
    <path fill="#fff" stroke="#757575" d="M1 1H17V13H1z" />
    <path fill="#B64343" d="M8 1.5H17V2.5H8z" />
    <path fill="#B64343" d="M1 3.5H17V4.5H1z" />
    <path fill="#B64343" d="M1 5.5H17V6.5H1z" />
    <path fill="#B64343" d="M1 7.5H17V8.5H1z" />
    <path fill="#B64343" d="M1 9.5H17V10.5H1z" />
    <path fill="#B64343" d="M1 11.5H17V12.5H1z" />
    <path fill="#354992" d="M1 1H8V6.5H1z" />
    <path
      d="m4.594 2.938.138.279.308.044-.223.218.052.306-.275-.144-.276.144.053-.306-.223-.218.308-.044zM2.719 2.938l.138.279.308.044-.223.218.052.306-.275-.144-.276.144.053-.306-.223-.218.308-.044zM3.656 2l.138.28.308.044-.223.217.053.307-.276-.145-.275.145.052-.307-.223-.217.308-.045zM3.656 3.875l.138.28.308.044-.223.217.053.307-.276-.145-.275.145.052-.307L3.21 4.2l.308-.045zM6.469 2.938l.138.279.308.044-.223.218.052.306-.275-.144-.276.144.053-.306-.223-.218.308-.044zM5.531 3.875l.138.28.308.044-.223.217.053.307-.276-.145-.275.145.052-.307-.223-.217.308-.045zM6.469 4.813l.138.279.308.044-.223.218.052.306-.275-.144-.276.144.053-.306-.223-.218.308-.044zM5.531 2l.138.28.308.044-.223.217.053.307-.276-.145-.275.145.052-.307-.223-.217.308-.045zM4.594 4.813l.138.279.308.044-.223.218.052.306-.275-.144-.276.144.053-.306-.223-.218.308-.044zM2.719 4.813l.138.279.308.044-.223.218.052.306-.275-.144-.276.144.053-.306-.223-.218.308-.044z"
      fill="#fff"
    />
    <path stroke="#757575" d="M1 1H17V13H1z" />
  </>,
  "UnitedStates",
  (strictLocalize) => ({
    viewBox: "0 0 18 14",
    fill: "none",
    titleAccess: strictLocalize({
      id: "+UUmdO",
      defaultMessage: "United States flag",
      description: { text: "The label for the United States flag icon" },
    }),
  })
);
